import type { VariantProps } from "class-variance-authority";
import React from "react";
import { Badge, badgeVariants } from "@components/ui/badge";
import { ActivityScope } from "@features/proposals/types/activity";

export const ActivityScopeBadge = ({
  variant,
  scope,
}: { scope?: ActivityScope } & VariantProps<typeof badgeVariants>) => {
  return (
    <Badge variant={variant ?? "outline"}>
      <span className="uppercase">{scope}</span>
    </Badge>
  );
};
